import { createContext, type RefObject } from 'react';

export const PieChartOverlayRefContext = createContext<
  RefObject<HTMLElement | null> | undefined
>(undefined);
